<template>
  <div>
    <cabecalho :ar="ar"></cabecalho>
    <div class="app-content">
      <div class="heading">Agendamento de validação cadastral</div>
      <b-alert v-model="showErro" variant="danger" class="white-space-pre">{{mensagemErro}}</b-alert>

      <div class="search-box" v-if="!showErro && !showReagendamento">
        <div class="input-group mb-3">
          <b-button
            type="button"
            variant="secondary"
            v-on:click="getLocation()"
            class="btn-sd"
            :disabled="loading"
          >
            <font-awesome-icon icon="map-marker-alt" class="location-button-icon" />
            <span class="location-button-text">Salas mais próximas</span>
          </b-button>
          <div style="padding:0.5rem;">ou</div>
          <b-form-input
            autocomplete="off"
            :disabled="loading"
            type="search"
            class="form-control"
            id="input-search"
            name="input-search"
            placeholder="Buscar por bairro ou cidade"
            aria-label="Buscar por bairro ou cidade"
            aria-describedby="basic-addon2"
            v-model="inputSearch"
          ></b-form-input>
        </div>
      </div>

      <div v-if="loading" class="text-center" style="margin-top: 4rem;">
        <b-spinner label="Loading..."></b-spinner>
      </div>

      <div v-if="!loading && !showErro" class="rooms-grid">
        <b-card
          no-body
          class="shadow-sm mb-2 card-room rounded"
          v-for="room in roomsPaginated()"
          v-bind:key="room.id"
          tag="article"
          style="text-transform: capitalize"
        >
          <b-row no-gutters v-bind:class = "(room.surdo)?'card-libras-top-background':''">
            <imgroom :room="room" />
          </b-row>
          <b-card-body v-bind:title="room.nome">
            <span v-if="room.videoconferencia" style="text-transform:none;">
              Atendimento pela Internet utilizando um smartphone ou computador com câmera
              <br />
            </span>
            <span v-else>
              <span style="text-transform:none;">Atendimento presencial em:</span>
              <br />
              {{room.rua}}, {{room.bairro}}
              <br />
              {{room.cidade}} - {{room.estado}}
            </span>
            <br />
            <div>
              <span
                v-if="room.disponivel"
                style="color:var(--main-color); text-transform:none; float:left"
              >Disponível {{weekdaysUTC[new Date(room.inicioProximoEvento).getUTCDay()]}}, {{new Date(room.inicioProximoEvento).getUTCDate()}}/{{new Date(room.inicioProximoEvento).getUTCMonth()+1}}</span>
              <router-link
                v-if="room.disponivel"
                class="btn button-card btn-primary btn-sd"
                style="margin-top: 1rem;"
                :to="{path: '/order/step/schedule/room/' + room.id}"
              >Ver agenda</router-link>
              <b-button
                type="button"
                variant="primary"
                v-if="!room.disponivel"
                class="btn button-card btn-primary btn-sd"
                style="margin-top: 1rem;"
                :disabled="true"
              >Indisponível</b-button>
            </div>
          </b-card-body>
        </b-card>

        <div v-if="totalRows()==0 && !showReagendamento">
          <b-card
            no-body
            class="shadow-sm mb-2 card-room rounded"
            tag="article"
            style="text-transform: capitalize"
          >
            <b-row no-gutters>
              <imgroom :room="{videoconferencia:false}" />
            </b-row>
            <b-card-body title="Não encontrado">
              <span style="text-transform:none;">Nenhuma sala encontrada</span>
            </b-card-body>
          </b-card>
        </div>
        <div v-if="showReagendamento">
          <b-card class="shadow-sm mb-2 bg-white rounded">
            <div class="d-block" style="color:var(--main-color-darker-alpha8);">
              Agendado para:
              <br />
              <span class="font-weight-bold">{{eventoAgendado.local.nome}}</span>
              <br />
                <template v-if="!eventoAgendado.local.videoconferencia">
                {{eventoAgendado.local.rua}}, {{eventoAgendado.local.bairro}}
                <br />
                {{eventoAgendado.local.cidade}} - {{eventoAgendado.local.estado}}
                <br />
              </template>
              <span class="font-weight-bold">{{eventoAgendado.horario.de.substring(8,10) + '/' + eventoAgendado.horario.de.substring(5,7) + '/' + eventoAgendado.horario.de.substring(0,4)}} às {{eventoAgendado.horario.de.substring(11,16)}}</span>
            </div>
          </b-card>
          <b-card
            no-body
            class="shadow-sm mb-2 card-room rounded"
            tag="article"
            style="text-transform: capitalize"
          >
            <b-row no-gutters>
              <imgcard :type="'online_calendar'" />
            </b-row>
            <b-card-body title="Reagendamento">
              <span
                style="text-transform:none;"
              >O seu agendamento já foi realizado, mas você ainda pode reagendar.</span>
              <b-button
                type="button"
                variant="primary"
                class="btn button-card btn-primary btn-sd"
                style="margin-top: 1rem;"
                @click="goToReagendamento()"
              >Reagendar</b-button>
            </b-card-body>
          </b-card>
        </div>
      </div>

      <div v-if="!loading && !showErro" style="margin-top:0.5rem;">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows()"
          v-if="totalRows() > perPage"
          pills
          :per-page="perPage"
          align="center"
          size="2x"
        ></b-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import cabecalho from "./components/Cabecalho.vue";
import imgroom from "./components/ImgRoom.vue";
import imgcard from "./components/ImgCard.vue";

export default {
  components: {
    cabecalho,
    imgroom,
    imgcard
  },
  data() {
    return {
      mensagemErro: null,
      showErro: false,
      loading: false,
      rooms: [],
      perPage: null,
      currentPage: 1,
      ar: this.loadArFromCache(),
      latitude: 0.0,
      longitude: 0.0,
      inputSearch: "",
      weekdaysUTC: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
      showReagendamento: false,
      eventoAgendado: null,
    };
  },
  created() {
    if (this.$route.query.t && this.$route.query.tid) {
      sessionStorage.setItem("token", "Bearer " + this.$route.query.t);
      this.verificarStatusPedido();
    } else {
      this.obterSalas();
    }

    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
  methods: {
    obterSalas: function () {
      this.showReagendamento = false;
      this.showErro = false;
      this.loading = true;
      this.$http
        .get(
          this.$serviceUrl + "/registerauthority/rooms",
          {
            headers: {
              Authorization: sessionStorage.getItem("token"),
              latitude: this.latitude + "",
              longitude: this.longitude + "",
            },
          }
        )
        .then(
          (resp) => {
            this.rooms = resp.body;
            this.loading = false;
          },
          (resp) => {
            if (resp.status == 404) {
              this.mensagemErro = "Nenhuma sala encontrada.";
            } else {
              this.mensagemErro = resp.body.message;
            }
            this.showErro = true;
            this.loading = false;
          }
        );
    },
    verificarStatusPedido: function () {
      this.loading = true;
      this.showErro = false;
      this.$http
        .get(this.$serviceUrl + "/order/schedule/exists", {
          headers: {
            Authorization: sessionStorage.getItem("token"),
          },
        })
        .then(
          (resp) => {
            this.loading = false;
            if (resp.body == true) {
              this.obterArInfo(false);
              if (!sessionStorage.getItem("reagendamento")) {
                this.showReagendamento = true;
                this.obterDadosAgendamento();
              } else {
                this.obterSalas();
              }
            } else {
              this.obterArInfo(true);
            }
          },
          (resp) => {
            if (resp.status == 404) {
              this.mensagemErro = "Solicitação não encontrada.";
            } else {
              this.mensagemErro = resp.body.message;
            }
            this.showErro = true;
            this.loading = false;
          }
        );
    },
    obterArInfo: function (loadSalas) {
      this.showErro = false;
      this.$http
        .get(
          this.$serviceUrl + "/registerauthority/info-by-schedule", {
          headers: {
            Authorization: sessionStorage.getItem("token"),
          },
        }
        )
        .then(
          (resp) => {
            this.arInfo = resp.body;
            sessionStorage.setItem(
              "arAndCertificate",
              JSON.stringify(this.arInfo)
            );
            this.ar = this.loadArFromCache();
            document.body.style.setProperty(
              "--main-color",
              this.arInfo.mainColor
            );
            document.body.style.setProperty(
              "--main-color-darker-alpha8",
              this.arInfo.mainColorDarkerAlpha8
            );
            document.body.style.setProperty(
              "--main-color-darker-alpha2",
              this.arInfo.mainColorDarkerAlpha2
            );
            if (loadSalas) {
              this.obterSalas();
            }
          },
          (resp) => {
            if (resp.status == 404) {
              this.mensagemErro = "Certificado não encontrado.";
            } else {
              this.mensagemErro = resp.body.message;
            }
            this.showErro = true;
          }
        );
    },
    obterDadosAgendamento : function() {
      this.loading = true;
      this.showErro = false;
      this.$http
        .get(this.$serviceUrl + "/order/info/event", {
          headers: {
            Authorization: sessionStorage.getItem("token"),
          },
        })
        .then(
          (resp) => {
            this.loading = false;
            this.eventoAgendado = resp.body;
          },
          (resp) => {
            if (resp.status == 404) {
              this.mensagemErro = "Agendamento da solicitação não encontrada.";
            } else {
              this.mensagemErro = resp.body.message;
            }
            this.showErro = true;
            this.loading = false;
          }
        );
    },
    loadArFromCache: function () {
      var arAndCertificate = sessionStorage.getItem("arAndCertificate");
      if (arAndCertificate != null) {
        return JSON.parse(arAndCertificate);
      }
      return null;
    },
    getLocation: function () {
      this.showErro = false;
      this.loading = true;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            this.latitude = position.coords.latitude;
            this.longitude = position.coords.longitude;
            this.obterSalas();
          },
          () => {
            this.loading = false;
          }
        );
      } else {
        this.mensagemErro = "Este navegador não suporta geolocalização.";
        this.loading = false;
        this.showErro = true;
      }
    },
    roomsPaginated: function () {
      return this.rooms
        .filter(this.filterRooms)
        .slice(
          (this.currentPage - 1) * this.perPage,
          this.currentPage * this.perPage
        );
    },
    totalRows: function () {
      return this.rooms.filter(this.filterRooms).length;
    },
    handleResize: function () {
      this.perPage = window.innerWidth < 1440 ? 6 : 8;
    },
    filterRooms: function (room) {
      return (
        room.bairro
          .trim()
          .toUpperCase()
          .includes(this.inputSearch.trim().toUpperCase()) ||
        room.cidade
          .trim()
          .toUpperCase()
          .includes(this.inputSearch.trim().toUpperCase())
      );
    },
    goToReagendamento: function () {
      sessionStorage.setItem("reagendamento", true);
      this.obterSalas();
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/Rooms.vue